import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ContentfulService } from '../contentful.service';
import { Router } from "@angular/router";
import { Entry } from 'contentful';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  host: {
    '(window:scroll)': 'updateHeader($event)'
  }
})
export class HomeComponent implements OnInit, AfterViewInit {

  public items: Entry<any>[] = [];
  public about : Entry<any>[] = [];

  isScrolled = false;
  currPos: any = 0;
  opacity: any = 0.5;
  startPos: Number = 0;
  changePos: Number = 100;

  @ViewChild('image') elementView: ElementRef;
  viewWidth: number = 50;

  public imageWidth:number = 1280;

  constructor(private contentfulService: ContentfulService, private router: Router) { }

  ngOnInit() {
    this.about = this.contentfulService.about;
    this.items = this.contentfulService.items;
    console.log("About",this.about);
    this.imageWidth = window.innerWidth > 1280 ? 1280 : 1080;
  }
  ngAfterViewInit(){
    console.log(this.elementView);
    if(this.elementView){
      this.viewWidth = this.elementView.nativeElement.offsetWidth;
    }
  }
 
  

  updateHeader(evt) {
    this.currPos = evt.target.scrollingElement.scrollTop - evt.target.scrollingElement.clientTop;
    this.currPos = (this.currPos != NaN) ? this.currPos : 0;
    this.opacity = 0.5 - ( this.currPos / 100);
  }

  pickProject(id : string){
    this.router.navigate(["/project/" + id]);
  }
  
}



// WEBPACK FOOTER //
// C:/Users/timva/Documents/Work/LatestDownload/src/app/home/home.component.ts